import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
    const [isAuthenticated, setIsAuthenticated] = useState(null);

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL || "https://maraton.klubmalydunaj.sk/api"}/verify-token`, {
                    method: "GET",
                    credentials: "include", // Include cookies in the request
                });

                if (response.ok) {
                    setIsAuthenticated(true);
                } else {
                    setIsAuthenticated(false);
                }
            } catch (err) {
                setIsAuthenticated(false);
            }
        };

        checkAuth();
    }, []);

    if (isAuthenticated === null) {
        return <div>Loading...</div>; // Show a loading state while checking authentication
    }

    return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
}

export default ProtectedRoute;
